import { breadcrumbSchema, clinicListSchema } from "../structured-data-core";
import { clinicsIn } from "../clinics";

// A hub page lists the clinics and links to each clinic's own page. The
// clinic nodes live on those pages, not here.
export function getChicagoStructuredData() {
  return [
    clinicListSchema("RESTORE Hair clinics in Chicago", "/locations/restore-chicago/", clinicsIn("chicago")),
    breadcrumbSchema([
      { name: "Locations", path: "/locations/" },
      { name: "Chicago", path: "/locations/restore-chicago/" },
    ]),
  ];
}
